import Cookies from 'js-cookie'
import Alpine from 'alpinejs'

document.addEventListener('alpine:init', () => {
    Alpine.store('timezone', {
        
        value: 'Europe/Madrid',
        
        init() {
            this.initTimeZone()
            const initialValue = this.value
            Alpine.effect(() => {
                if(initialValue !== this.value) {
                    Cookies.set('timezone', this.value, { 'expires' : 365, 'path' : '/'})
                }
            })
        },
        
        initTimeZone() {
            let tz = this.findMatchingTimeZone(Cookies.get('timezone'), null)
            if(tz) {
                this.value = tz.name
                return
            }

            // attempt to derive from client
            try {
                const clientTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone
                if(!clientTimeZoneName) {
                    return
                }                
                tz = this.findMatchingTimeZone(clientTimeZoneName, this.getOffsetMinutes(clientTimeZoneName))
                if(tz) {
                    this.value = tz.name
                }
            } catch {}
        },
        
        findMatchingTimeZone(timezone, offsetMinutes) {
            
            const directMatch = window.timeZoneList.find(tz => tz.name === timezone)
            if(directMatch) {
                return directMatch
            }
            if(!offsetMinutes) {
                return null
            }

            const group = timezone.split('/')[0]
            const similarMatch = window.timeZoneList.find(tz => tz.name.split('/')[0] === group && tz.offset === offsetMinutes)
            if(similarMatch) {
                return similarMatch
            }
            
            return null
        },

        getOffsetMinutes(timezone) {
            const date = new Date()
            const parts = new Intl.DateTimeFormat('en-US', {
                timeZone: timezone,
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false,
            }).formatToParts(date)
            const getPart = (type) => parseInt(parts.find(p => p.type === type).value, 10)
            const year = getPart('year')
            const month = getPart('month') - 1 // 0-indexed
            const day = getPart('day')
            const hour = getPart('hour')
            const minute = getPart('minute')
            const second = getPart('second')
            const localDateInUTC = Date.UTC(year, month, day, hour, minute, second, date.getMilliseconds())
            const utcTime = date.getTime()
            return (localDateInUTC - utcTime) / (60 * 1000)
        }
        
    })
})

